import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
const SearchResults = ({ results, searchTerm, containerRef }) => {
  const navigate = useNavigate();
  if (!searchTerm || results.length === 0) return null;

  const highlightMatch = (text, term) => {
    if (!term) return text;
    const regex = new RegExp(`(${term})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="text-orange-500 font-semibold">
          {part}
        </span>
      ) : (
        <span key={index} className="text-gray-900">
          {part}
        </span>
      ),
    );
  };
  const handleSearchResultClick = (articleId) => {
    navigate(`/help/${articleId}`);
  };
  return (
    <div
      ref={containerRef}
      className="absolute top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto"
    >
      <div className="py-2">
        {results.map((article, index) => (
          <div
            key={index}
            className="px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors"
            onClick={() => handleSearchResultClick(article._id)}
          >
            <p className="text-sm leading-snug">
              {highlightMatch(article.title, searchTerm)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

const SearchIcon = () => (
  <svg
    className="w-4 h-4 text-gray-400"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    viewBox="0 0 24 24"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);

export const HelpCenterArticleSearchBar = ({ placeholder = "search" }) => {
  const allArticles = useSelector((state) => state.helpCenterArticles);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const containerRef = useRef(null);

  const navigate = useNavigate();

  //filter articles based on search term
  useEffect(() => {
    if (searchTerm.trim()) {
      const filtered = allArticles.filter((article) =>
        article.title.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setSearchResults(filtered);
    } else {
      setSearchResults([]);
    }
  }, [searchTerm, allArticles]);

  const handleSearchBarChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchBarKeyDown = (e) => {
    if (e.key === "Enter" && searchTerm.trim()) {
      const value = searchTerm.split(" ").join("%20");
      navigate(`/help/search?key=${value}`);
    }
  };

  return (
    <>
      <SearchIcon />
      <input
        type="text"
        placeholder={`${placeholder}`}
        className="flex-1 text-sm text-gray-600 outline-none bg-transparent placeholder-gray-400"
        value={searchTerm}
        onChange={handleSearchBarChange}
        onKeyDown={handleSearchBarKeyDown}
      />
      <SearchResults
        results={searchResults}
        searchTerm={searchTerm}
        containerRef={containerRef}
      />
    </>
  );
};
